<eq-loader [isLoader]="true"></eq-loader>